import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const projectDirectoryRedirectRoute: InvariantJiraRoute = {
	name: 'project-directory-redirect',
	path: '/secure/RapidBoard.jspa',
};
